@if(contractData && isPlanFfs) {
@for(item of contractData.baseContract.ffs; track item) {
<p-message styleClass="border-none outline-none border-noround px-3 py-2 shadow-2 bg-slate-700 text-white"
    severity="contrast" data-auto-id="ffs-banner">
    @if(item) {
    <div class="mb-2" (click)="onBannerContentClick($event, item)" [innerHTML]="(item.webBanner ?? '') | convertHtml">
    </div>
    }
</p-message>
@if(!$last) {
<p-divider styleClass="my-0"></p-divider>
}
}
}